/* eslint-disable prettier/prettier */
import { Pressable, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet } from 'react-native'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { useSelector } from 'react-redux'
import { themeSelector } from '../../redux/theme/selector'
import { goBack } from '../../services/navigation'
import { theme } from '../../theme'
import { theme as defaultTheme } from '../../theme/theme'
import { Body, Header, Left, Right, Title } from '../NativeBaseLegacy'

export const WIDTH_LEFT_RIGHT = 80

interface Props {
  title?: string
  titleImage?: string | null
  left?: React.ReactNode
  right?: React.ReactNode
  headerBackgroundColor?: string
  children?: React.ReactNode
}

type LeftButtonBackType = {
  color?: string
  action?: () => void
}

export const Page: FunctionComponent<Props> = ({ title, titleImage, children, left, right }) => {
  const theme = useSelector(themeSelector)

  const renderTitle = () => {
    if (titleImage) {
      return <Image style={styles.image} source={{ uri: titleImage }} resizeMode="contain" />
    }

    return <Title style={[styles.titleText, { color: theme?.titleFontColor }]}>{title}</Title>
  }

  return (
    <View style={[styles.container, { backgroundColor: defaultTheme?.colors.white }]}>
      <Header>
        <Left style={styles.left}>{left || undefined}</Left>
        <Body style={styles.body}>{renderTitle()}</Body>
        <Right style={styles.right}>{right || undefined}</Right>
      </Header>
      {children}
    </View>
  )
}

export const LeftButtonBack: FunctionComponent<LeftButtonBackType> = ({ color, action = null }) => {
  const themeResult = useSelector(themeSelector)
  return (
    <Pressable onPress={action || goBack} style={styles.backButton}>
      <Ionicons name="chevron-back" color={color || themeResult?.titleFontColor} size={26} />
    </Pressable>
  )
}

export function LeftRoundButtonBack() {
  const themeResult = useSelector(themeSelector)
  return (
    <Pressable onPress={goBack} style={[styles.roundButton, { backgroundColor: themeResult?.brandPrimary }]}>
      <Ionicons name="chevron-back" color={themeResult?.titleFontColor} size={28} />
    </Pressable>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexBasis: theme.deviceHeight,
  },
  left: {
    zIndex: 2,
    flex: 0,
    width: 100,
  },
  body: {
    justifyContent: 'center',
    flex: 1,
    zIndex: 1,
    alignItems: 'center',
  },
  right: {
    zIndex: 2,
    flex: 0,
    width: 100,
    justifyContent: 'flex-end',
  },
  titleText: {
    fontSize: theme.textSize.x2_50,
    fontWeight: 'bold',
  },
  image: {
    height: '100%',
    width: '100%',
    marginBottom: theme.padding.x1,
  },
  backButton: {
    padding: theme.padding.x1,
  },
  roundButton: {
    width: 50,
    height: 50,
    borderRadius: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
